<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="直播课程" goBack="true"></head-top>
	</div>
</template>

<script>
	import headTop from "@/components/common/head.vue";
	import api from "@/apis/api";
	import {
		mapGetters
	} from "vuex";
	export default {
		name: "Live",
		components: {
			headTop: headTop,
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				id: null, // 课程章节ID
				token: undefined,
			};
		},
		created() {},
		activated() {
			this.token = this.getToken()
			this.id = this.$route.query.id
			this.toBjyLivePage(this.id);
		},
		computed: {
			...mapGetters("userModule", ["getToken"]),
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				this.token = this.getToken()
				this.toBjyLivePage(this.id);
			},

			toBjyLivePage(id) {
				if (this.getToken()) {
					// 先判断是否购买，再跳转直播页面
					api.get('/curriculum/ifBindCurriculumByCurriculumChapterId/' + id).then((res) => {
						if (res.success) {
							return api.get('/curriculum/getBjyLivePageUrl/' + id);
						} else {
							this.toCurriculumIndex(res.message);
						}
					}).then((res) => {
						if (res.success) {
							location.href = res.data
						} else {
							this.$toast(res.message)
						}
					})
				} else {
					api.get('/p/curriculum/getBjyLivePageUrl/' + id).then((res) => {
						if (res.success) {
							if (res.data != null) {
								location.href = res.data
							} else {
								this.$store.commit('userModule/SET_login_popup_show', true)
							}
						} else {
							this.toCurriculumIndex(res.message);
						}
					})
				}

				// api.get('/p/curriculum/getBjyLivePageUrl/' + id).then((res)=>{
				//     if(res.success){
				//         if (res.data != null) {
				//             location.href = res.data
				//         } else {
				//             return api.get('/curriculum/getBjyLivePageUrl/' + id);
				//         }
				//     } else {
				//         this.$toast(res.message)
				//     }
				// }).then((res)=>{
				//     if (res.success) {
				//         location.href = res.data
				//     } else {
				//         this.$toast(res.message)
				//     }
				// })
			},
			toCurriculumIndex(message) {
				this.$dialog.alert({
					title: '温馨提示',
					message: message,
					theme: 'round-button',
					confirmButtonText: '首页',
					confirmButtonColor: '#38F',
				}).then(() => {
					this.$router.push({
						'path': '/main/curriculum_index',
					})
				})
			}
		},
	};
</script>